import { useState } from "react";

const categories = [
  {
    key: "star",
    label: "88黑料明星",
    icon: "ri-star-line",
    desc: "演员 / 歌手 / 偶像",
  },
  {
    key: "wanghong",
    label: "88黑料网红",
    icon: "ri-focus-3-line",
    desc: "带货 / 生活 / 颜值博主",
  },
  {
    key: "zhibo",
    label: "88黑料主播",
    icon: "ri-live-line",
    desc: "游戏 / 娱乐 / 电台主播",
  },
  {
    key: "public",
    label: "88黑料公众人物",
    icon: "ri-quill-pen-line",
    desc: "创作者 / 大V / 公益人",
  },
] as const;

type CatKey = (typeof categories)[number]["key"];

const personData: Record<CatKey, { name: string; meta: string; summary: string; count: string; status: string; tone: string }[]> = {
  star: [
    { name: "顾言泽", meta: "歌手", summary: "巡演争议、代言与回应按时间归档，核心 3 节点。", count: "23 条", status: "争议中", tone: "accent" },
    { name: "沈嘉茉", meta: "演员", summary: "剧组合作相关线索 2 条，关联人物逐步补全。", count: "9 条", status: "待证实", tone: "primary" },
    { name: "温静怡", meta: "偶像", summary: "出道早期言论、舞台与物料对照整理中。", count: "16 条", status: "争议中", tone: "accent" },
    { name: "秦之昂", meta: "演员", summary: "片酬、合同相关背景梳理，已核实部分单列。", count: "7 条", status: "已归档", tone: "secondary" },
  ],
  wanghong: [
    { name: "桃桃酱", meta: "带货博主", summary: "合作发布与删除记录按年顺排，背景更清晰。", count: "31 条", status: "争议中", tone: "accent" },
    { name: "老铁阿贵", meta: "生活博主", summary: "事件时间线已补齐，关联方关系页面可查。", count: "14 条", status: "已归档", tone: "secondary" },
    { name: "麻辣丸子", meta: "带货博主", summary: "2022 年后内容已入档，早期素材仍在征集。", count: "11 条", status: "待证实", tone: "primary" },
  ],
  zhibo: [
    { name: "电竞KK", meta: "游戏主播", summary: "早期直播言论文字记录已归档并附回应。", count: "27 条", status: "争议中", tone: "accent" },
    { name: "说书人老白", meta: "娱乐主播", summary: "多次转述内容与来源标注，条目分区存放。", count: "6 条", status: "待证实", tone: "primary" },
    { name: "深夜阿宁", meta: "电台主播", summary: "个人言论时间线整理，已核实部分完成。", count: "12 条", status: "已归档", tone: "secondary" },
    { name: "游戏酱zz", meta: "游戏主播", summary: "赛事期言行与舆论对照，持续补档中。", count: "8 条", status: "待证实", tone: "primary" },
  ],
  public: [
    { name: "林岳", meta: "财经大V", summary: "合同细节与公开签约信息整理成时间线。", count: "19 条", status: "争议中", tone: "accent" },
    { name: "许砚舟", meta: "公益人", summary: "组织公示期信息与各方回应分区归档。", count: "10 条", status: "已归档", tone: "secondary" },
    { name: "方闻", meta: "专栏作者", summary: "多篇旧文内容随时间轴补齐对照说明。", count: "13 条", status: "待证实", tone: "primary" },
  ],
};

const statusTone: Record<string, string> = {
  accent: "bg-accent-100 text-accent-800",
  primary: "bg-primary-100 text-primary-700",
  secondary: "bg-secondary-100 text-secondary-800",
};

export default function ArchiveSection() {
  const [active, setActive] = useState<CatKey>("star");
  const cur = categories.find((c) => c.key === active)!;
  const list = personData[active];

  return (
    <section id="archive" className="scroll-mt-24 bg-background-100">
      <div className="mx-auto w-full max-w-6xl px-4 py-10 md:py-14">
        <div className="text-center">
          <p className="mb-1 text-xs font-semibold tracking-widest text-primary-500">ARCHIVE</p>
          <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            人物档案 · 按名字建档的黑料百科
          </h2>
          <p className="mx-auto mt-2 max-w-2xl text-sm text-foreground-500">
            同一个人的料不会散落在各个帖子里——明星、网红、主播、公众人物，选一个分区，进入某个人物的档案主页逐条对照。
          </p>
        </div>

        {/* 分类 Tab */}
        <div className="mx-auto mt-7 flex max-w-full flex-wrap justify-center gap-1 rounded-full border border-background-200 bg-background-50 p-1">
          {categories.map((c) => (
            <button
              key={c.key}
              type="button"
              onClick={() => setActive(c.key)}
              className={`flex items-center gap-1.5 whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors md:px-5 ${
                active === c.key
                  ? "bg-primary-500 font-semibold text-background-50"
                  : "text-foreground-600 hover:text-primary-600"
              }`}
            >
              <i className={c.icon} />
              <span>{c.label}</span>
            </button>
          ))}
        </div>

        <p className="mt-4 text-center text-sm text-foreground-500">
          {cur.icon && <i className={`${cur.icon} mr-1 text-primary-500`} />}
          当前分区：<b className="text-foreground-800">{cur.label}</b> · {cur.desc} · 收录 <b className="text-primary-600">{list.length} 位人物</b>
        </p>

        <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {list.map((p) => (
            <article
              key={p.name}
              className="group flex flex-col rounded-2xl border border-background-200 bg-background-50 p-5 transition-all hover:-translate-y-0.5 hover:border-primary-200"
            >
              <div className="flex items-center gap-3">
                <span className="font-heading flex h-11 w-11 items-center justify-center rounded-full bg-background-200 text-base font-bold text-foreground-700">
                  {p.name.slice(0, 1)}
                </span>
                <div className="min-w-0">
                  <h3 className="cursor-pointer truncate text-[16px] font-bold text-foreground-950 group-hover:text-primary-700">
                    {p.name}
                  </h3>
                  <p className="text-xs text-foreground-400">{p.meta}</p>
                </div>
                <span className={`ml-auto whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-medium ${statusTone[p.tone]}`}>
                  {p.status}
                </span>
              </div>
              <p className="mt-3.5 flex-1 text-sm leading-6 text-foreground-500">{p.summary}</p>
              <div className="mt-4 flex items-center justify-between border-t border-background-100 pt-3">
                <span className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-file-list-3-line" /> {p.count} 档案
                </span>
                <a
                  href="#archive"
                  className="flex items-center gap-0.5 whitespace-nowrap text-xs font-medium text-primary-600 hover:text-primary-700"
                  onClick={(e) => e.preventDefault()}
                >
                  进档案 <i className="ri-arrow-right-s-line" />
                </a>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-6 text-center">
          <button
            type="button"
            className="inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-primary-200 bg-background-50 px-5 py-2.5 text-sm font-medium text-primary-600 transition-colors hover:bg-primary-50"
          >
            查看更多{cur.label}档案 <i className="ri-arrow-down-line" />
          </button>
        </div>
      </div>
    </section>
  );
}